import React, { Component } from 'react';
import { TextImage } from '../../templates';
import { withLanguageContext } from '../../../utils/LanguageContext';

import './styles.css';

/**
 * The upload visuals section of the landing page.
 *
 * @typedef {Object} Props
 * @prop {Object} [content]
 *
 * @augments {Component<Props>}
 */
class UploadVisualsView extends Component {

	render () {
		const {
			content,
			heading,
			imageToRight,
		} = this.props.content.landingPage.uploadVisuals;

		return (
			<TextImage
				{...{
					content,
					heading,
					imageToRight,
				}}
				imageClassName='UploadVisualsView'
			/>
		);
	}

}

export default withLanguageContext(UploadVisualsView);



// WEBPACK FOOTER //
// ./src/components/views/UploadVisualsView/UploadVisualsView.js